import React from 'react';

import useOverElement from 'hooks/useOverElement';

import * as S from './ArticleRichText.styles';

export interface ArticleRichTextProps {
  data: {
    richText: string;
  };
}

const defaultProps: Partial<ArticleRichTextProps> = {};

const ArticleRichText: React.FunctionComponent<ArticleRichTextProps> = ({
  data,
  ...rest
}) => {
  const [ref] = useOverElement();

  return (
    <S.ArticleRichTextWrapper ref={ref} {...rest}>
      <S.RichText defaultSpacing richText={data.richText} />
    </S.ArticleRichTextWrapper>
  );
};

ArticleRichText.defaultProps = defaultProps;

export default ArticleRichText;
